import {useState, useEffect} from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import AccountCircle from '@mui/icons-material/AccountCircle';
import {signOut} from 'aws-amplify/auth';
import {useRouter} from 'next/navigation';
import QuestionnaireModal from 'components/Contact/questionnaire';
import AdminCategoryDialog from 'app/user/deals/adminCategoryDialog';
import {SecurityUtils} from 'pp-web';
import dinoMascot from '../../assets/img/dino-mascot.png'
import Image from 'next/image';
import {Box, AppBar, Toolbar, IconButton} from '@mui/material';

export default function UserDealNavbar({
    logo,
    user,
    questions,
    questionaireModal,
    setQuestionaireModal,
    setLoading,
    reset,
    doSearch,
    pageConfig,
    pageName,
    inputValue,
    setInputValue,
    initialSearch = ''
}) {
    const [anchorEl, setAnchorEl] = useState(null);


    useEffect(() => {
        setInputValue(initialSearch);
    }, [initialSearch]);

    const isMenuOpen = Boolean(anchorEl);
    const router = useRouter();

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const logout = async () => {
        setLoading(true);
        await signOut();
        router.push('/landing/deals');
        setLoading(false);
    };

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            if (inputValue.trim()) {
                doSearch(inputValue);
            }
        }
    };

    const handleReset = (event) => {
        setInputValue('');
        reset();
    }

    const menuId = 'primary-search-account-menu';
    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={menuId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={() => setQuestionaireModal(true)}>Edit Preferences</MenuItem>
            <MenuItem onClick={logout}>Logout</MenuItem>
        </Menu>
    );



    return (
        <Box sx={{flexGrow: 1}}>
            <AppBar position="static" sx={{
                background: 'transparent',
                boxShadow: 'none'
            }}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="logo"
                        onClick={handleReset}
                        sx={{ p: 0, '&:hover': { backgroundColor: 'transparent' } }}
                    >
                        <img src={logo?.url} alt={logo.alt} width="150" style={{ cursor: 'pointer' }}/>
                    </IconButton>
                    {user && <Box sx={{display: {xs: 'flex'}, marginLeft: 'auto'}}>
                        {SecurityUtils.hasRole(user, 'Admin') &&
                            <AdminCategoryDialog email={user?.email} setLoading={setLoading} pageName={pageName} />}
                        <IconButton
                            edge="end"
                            aria-label="account of current user"
                            aria-controls={menuId}
                            aria-haspopup="true"
                            onClick={handleProfileMenuOpen}
                            color="inherit"
                        >
                            <AccountCircle sx={{width: '35px', height: '35px!important', color: 'white'}}/>
                        </IconButton>
                    </Box>}
                </Toolbar>
            </AppBar>
            <div className="header-content">
                <Image
                    src={dinoMascot}
                    alt="Dinosaur mascot"
                    className="dino-background"
                />
                <h1 className="main-heading" sx={{
                    fontSize: {
                        xs: '1.5rem',
                        sm: '2rem',
                        md: '2.5rem',
                        lg: '3rem'
                    },
                    textAlign: 'center',
                    margin: '1rem 0',
                    lineHeight: 1.2,
                    wordWrap: 'break-word',
                    maxWidth: '100%',
                    padding: '0 1rem'
                }}>
                    {
                        pageConfig.heading.split(' ').map((word, i) => {
                            return i % 2 ? <span className="highlight" style={{ display: 'inline-block' }}>{word}</span> : word
                        })
                    }
                </h1>
                <h2 className="sub-heading">
                    {pageConfig.subHeading}
                </h2>
                <div className="search-container">
                    <InputBase
                        className="search-input"
                        value={inputValue}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyPress}
                        placeholder={pageConfig.searchPlaceholder}
                        inputProps={{'aria-label': 'search'}}
                    />
                    {inputValue && (
                        <button
                            className="clear-button"
                            onClick={handleReset}
                            aria-label="Clear search"
                        >
                            <CloseIcon />
                        </button>
                    )}
                    <div className="search-icon-wrapper">
                        <SearchIcon
                            onClick={() => inputValue.trim() && doSearch(inputValue)}
                            style={{ cursor: 'pointer' }}
                            sx={{
                                '@media (max-width: 600px)': {
                                    position: 'absolute',
                                    right: '16px',
                                    top: '50%',
                                    transform: 'translateY(-50%)'
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
            {user && renderMenu}
            {questionaireModal && (
                <QuestionnaireModal
                    questionaireModal={questionaireModal}
                    setQuestionaireModal={setQuestionaireModal}
                    questions={questions}
                    email={user?.email}
                    edit
                />
            )}
        </Box>
    );
}
